import React from 'react';

function CustomEventConfigurationReadView(props) {
  return <>{props && props.guardrail && props.guardrail.trigger && props.guardrail.trigger.configuration.eventType}</>;
}

export default CustomEventConfigurationReadView;
